import { useCallback, useState } from 'react';
import api from '../api';
import { QUALITY_SERVICE_API_URL } from '../config';

/**
 * Creates a real Jira 'Duplicate' link between two tickets (QA-7429), replacing the prototype's
 * local-only mark-as-duplicate action. Returns the server-computed linkState/duplicateLinks for
 * the source ticket so the caller can patch its row in place without waiting for a Jira re-sync.
 */
export default function useDuplicateLink() {
  const [linking, setLinking] = useState(false);

  const link = useCallback(async (sourceKey, targetKey) => {
    setLinking(true);
    try {
      const response = await api.post(`${QUALITY_SERVICE_API_URL}/hub/duplicates/link`, { sourceKey, targetKey });
      return response.data;
    } finally {
      setLinking(false);
    }
  }, []);

  return { link, linking };
}
